import { render } from "./StaffBox.vue?vue&type=template&id=77c03d56"
import script from "./StaffBox.vue?vue&type=script&lang=js"
export * from "./StaffBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__